import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
    en: {
        star: 'STAR',
        welcomeBack: 'Welcome Back',
        loginAndenjoy: 'Login and enjoy!',
        email: 'Email',
        password: 'Password',
        enterEmail: 'Enter Your Email',
        enterPassword: 'Enter Your Password',
        login: 'Login',
        yourDashboard: ' Your DashBoard',
        totalVideos: 'Total Created Video',
        history: 'History',
        acceptedMessage: 'Accepted Message',
        wantsVideo: 'wants to make a video for',
        fansMessages: 'Fans Messages',
        noDataAvailable: 'No data available',
        btnViewDetails: ' View details',
        fanMessage: 'Fan Message',
        requestedPerson: 'Request from',
        messageFor: 'Message For',
        message: 'Message',
        requestdate: 'Request Date',
        decline: 'Decline',
        accept: 'Accept',
        upload: 'Upload',
        fanHistory: 'Fans History',
        home: 'Home',
        likes: 'likes',
        Comments: 'Comments',
        PeopleHaveliked: 'People have liked',
        madeComments: 'People have made comments',
        btnViewProfile: ' View Profile',
        profile: 'Profile',
        invalidLoginPass: 'Invalid Login or Password!! Please try again',
        somethingWentwrong: 'Something went wrong!! Please try again',
        myProfile: 'My Profile',
        fansRecord: 'Fans Record',
        name: 'Name',
        profession: 'Profession',
        bio: 'Bio',
        setPrice: 'Set price',
        videoProfile: 'Video Profile',
        photoProfile: 'Photo Profile',
        socialProfile: 'Social Profile',
        uploadImage: ' Upload Photo',
        uploadVideo: 'Upload Video',
        newVideo: 'Upload new video or Photo',
        instagram: 'Instagram',
        view: 'View',
        noHistoryAvailable: 'No history available!',
        videoOrImage: 'Upload New Video or Image',
        createdVideofor: 'Created a video for',
        logout: 'Logout',
        cancel: 'Cancel',
        imageUploaded: 'Image Uploaded',
        videoUploaded: 'Video Uploaded',
        Submit: 'Submit',
        NoRecordsavailable: "No records available",

    },
    bn: {
        star: 'তারা',
        welcomeBack: 'ফিরে আসার জন্য স্বাগতম',
        loginAndenjoy: 'লগইন করুন এবং উপভোগ করুন!',
        email: 'ই-মেইল',
        password: 'পাসওয়ার্ড',
        enterEmail: 'তুমার ইমেইল প্রবেশ করাও',
        enterPassword: 'আপনার পাসওয়ার্ড লিখুন',
        login: 'প্রবেশ করুন',
        yourDashboard: 'আপনার ড্যাশবোর্ড',
        totalVideos: 'মোট তৈরি ভিডিও',
        history: 'ইতিহাস',
        acceptedMessage: 'স্বীকৃত বার্তা',
        wantsVideo: 'একটি ভিডিও জমা দিয়েছে',
        fansMessages: 'ভক্ত বার্তা',
        noDataAvailable: 'কোন তথ্য নেই',
        btnViewDetails: 'বিস্তারিত দেখুন',
        fanMessage: 'ফ্যান বার্তা',
        requestedPerson: 'কি অনুরোধ',
        messageFor: 'জন্য বার্তা',
        message: 'বার্তা',
        requestdate: 'অনুরোধ তারিখ',
        decline: 'পতন',
        accept: 'গ্রহণ করা',
        upload: 'আপলোড',
        fanHistory: 'ফ্যান ইতিহাস',
        home: 'বাড়ি',
        likes: 'পছন্দ',
        Comments: 'মন্তব্য',
        PeopleHaveliked: 'মানুষ পছন্দ করেছে',
        madeComments: 'মানুষ মন্তব্য করেছে',
        btnViewProfile: 'প্রোফাইল দেখুন',
        profile: 'প্রোফাইলের',
        invalidLoginPass: 'অবৈধ লগইন বা পাসওয়ার্ড !! আবার চেষ্টা করুন',
        somethingWentwrong: 'কিছু ভুল হয়েছে !! আবার চেষ্টা করুন',
        myProfile: 'আমার প্রোফাইল',
        fansRecord: 'ভক্ত রেকর্ড',
        name: 'নাম',
        profession: 'পেশা',
        bio: 'বায়ো',
        setPrice: 'দাম নির্ধারণ করো',
        videoProfile: 'ভিডিও প্রোফাইল',
        photoProfile: 'ফটো প্রোফাইল',
        socialProfile: 'সামাজিক প্রোফাইল',
        uploadImage: 'ছবি আপলোড করুন',
        uploadVideo: 'ভিডিও আপলোড করুন',
        newVideo: 'নতুন ভিডিও বা ফটো আপলোড করুন',
        instagram: 'ইনস্টাগ্রাম',
        view: 'দৃশ্য',
        noHistoryAvailable: 'কোনও ইতিহাস উপলব্ধ নেই',
        videoOrImage: 'নতুন ভিডিও বা ফটো আপলোড করুন',
        createdVideofor: 'একটি ভিডিও তৈরি করেছে',
        logout: 'প্রস্থান',
        cancel: 'বাতিল',
        imageUploaded: 'ছবি আপলোড করা হয়েছে',
        videoUploaded: 'ভিডিও আপলোড হয়েছে',
        Submit: 'জমা দিন',
        NoRecordsavailable: "কোন রেকর্ড উপলব্ধ",

    },
    gu: {
        star: 'સ્ટાર',
        welcomeBack: 'સ્વાગત પાછા',
        loginAndenjoy: 'લ loginગિન અને આનંદ!',
        email: 'ઇમેઇલ',
        password: 'પાસવર્ડ',
        enterEmail: 'તમારું ઈમેલ એડ્રેસ લખો',
        enterPassword: 'તમારો પાસવર્ડ દાખલ કરો',
        login: 'લ .ગિન',
        yourDashboard: 'તમારું ડેશબોર્ડ',
        totalVideos: 'કુલ બનાવેલ વિડિઓ',
        history: 'ઇતિહાસ',
        acceptedMessage: 'સ્વીકૃત સંદેશ',
        wantsVideo: 'વિડિઓ સબમિટ કરી છે',
        fansMessages: 'ચાહકો સંદેશા',
        noDataAvailable: 'કોઈ ડેટા ઉપલબ્ધ નથી',
        btnViewDetails: 'વિગતો જુઓ',
        fanMessage: 'ચાહક સંદેશ',
        requestedPerson: 'શું વિનંતી',
        messageFor: 'માટે સંદેશ',
        message: 'સંદેશ',
        requestdate: 'વિનંતી તારીખ',
        decline: 'અસ્વીકાર',
        accept: 'સ્વીકારો',
        upload: 'અપલોડ કરો',
        fanHistory: 'ચાહક ઇતિહાસ',
        home: 'ખેર',
        likes: 'ગમ્યું',
        Comments: 'ટિપ્પણીઓ',
        PeopleHaveliked: 'લોકોને ગમ્યું',
        madeComments: 'લોકોએ ટિપ્પણી કરી છે',
        btnViewProfile: 'પ્રોફાઇલ જુઓ',
        profile: 'પ્રોફાઇલ',
        invalidLoginPass: 'અમાન્ય લ loginગિન અથવા પાસવર્ડ !! કૃપા કરી ફરીથી પ્રયત્ન કરો',
        somethingWentwrong: 'કંઈક ખોટું થયું !! કૃપા કરી ફરીથી પ્રયત્ન કરો',
        myProfile: 'મારી પ્રોફાઇલ',
        fansRecord: 'ચાહકો રેકોર્ડ',
        name: 'નામ',
        profession: 'વ્યવસાય',
        bio: 'બાયો',
        setPrice: 'ભાવ નક્કી કરો',
        videoProfile: 'વિડિઓ પ્રોફાઇલ',
        photoProfile: 'ફોટો પ્રોફાઇલ',
        socialProfile: 'સામાજિક પ્રોફાઇલ',
        uploadImage: 'ફોટો અપલોડ કરો',
        uploadVideo: 'વિડિઓ અપલોડ કરો',
        newVideo: 'નવી વિડિઓ અથવા ફોટો અપલોડ કરો',
        instagram: 'ઇન્સ્ટાગ્રામ',
        view: 'જુઓ',
        noHistoryAvailable: 'કોઈ ઇતિહાસ ઉપલબ્ધ નથી',
        videoOrImage: 'નવી વિડિઓ અથવા ફોટો અપલોડ કરો',
        createdVideofor: 'વીડિયો બનાવ્યો છે',
        logout: 'લૉગ આઉટ',
        cancel: 'રદ કરો',
        imageUploaded: 'ફોટો અપલોડ કરાયો',
        videoUploaded: 'વિડિઓ અપલોડ થઈ',
        Submit: 'સબમિટ કરો',
        NoRecordsavailable: "કોઈ રેકોર્ડ ઉપલબ્ધ નથી",

    },
    hi: {
        star: 'स्टार',
        welcomeBack: 'आपका स्वागत है',
        loginAndenjoy: 'लॉगिन करें और आनंद लें!',
        email: 'ईमेल',
        password: 'पासवर्ड',
        enterEmail: 'अपना ईमेल दर्ज करें',
        enterPassword: 'अपना पासवर्ड दर्ज करें',
        login: 'लॉग इन करें',
        yourDashboard: 'आपका डैशबोर्ड',
        totalVideos: 'कुल बनाया गया वीडियो',
        history: 'हिस्ट्री ',
        acceptedMessage: 'स्वीकार किया हुआ संदेश',
        wantsVideo: 'ने वीडियो निवेदन किआ  है',
        fansMessages: 'प्रशंसकों के संदेश',
        noDataAvailable: 'कोई डेटा उपलब्ध नहीं है',
        btnViewDetails: 'विवरण देखें',
        fanMessage: 'प्रशंसक संदेश',
        requestedPerson: 'किस्से निवेदन',
        messageFor: 'किसके लिए सन्देश',
        message: 'संदेश',
        requestdate: 'निवेदन की तारीख',
        decline: 'अस्वीकार करें',
        accept: 'स्वीकार करें',
        upload: 'अपलोड करें ',
        fanHistory: 'प्रशंसक हिस्ट्री ',
        home: 'होम ',
        likes: 'पसंद किया ',
        Comments: 'टिप्पणियाँ',
        PeopleHaveliked: 'लोगों ने पसंद किया है',
        madeComments: 'लोगों ने टिप्पणियां की हैं',
        btnViewProfile: 'प्रोफाइल देखिये',
        profile: 'प्रोफाइल',
        invalidLoginPass: 'अमान्य लॉगिन या पासवर्ड!! कृपया पुन: प्रयास करें',
        somethingWentwrong: 'कुछ गलत हो गया!! कृपया पुन: प्रयास करें',
        myProfile: 'मेरी प्रोफाइल',
        fansRecord: 'प्रशंसक रिकॉर्ड',
        name: 'नाम',
        profession: 'व्यवसाय',
        bio: 'बायो ',
        setPrice: 'कीमत निर्धारित करें',
        videoProfile: 'वीडियो प्रोफाइल',
        photoProfile: 'फोटो प्रोफाइल',
        socialProfile: 'सामाजिक प्रोफ़ाइल',
        uploadImage: 'तस्वीर अपलोड करे ',
        uploadVideo: 'वीडियो अपलोड करें',
        newVideo: 'नया वीडियो या तस्वीर अपलोड करें',
        instagram: 'इन्स्टाग्राम',
        view: 'देखें',
        noHistoryAvailable: 'कोई हिस्टरी उपलब्ध नहीं है',
        videoOrImage: 'नया वीडियो या फोटो अपलोड करें',
        createdVideofor: 'ने वीडियो  बनाया है',
        logout: 'लॉग आउट',
        cancel: 'रद्द करें',
        imageUploaded: 'फ़ोटो अपलोड की गई',
        videoUploaded: 'वीडियो अपलोड किया गया',
        Submit: 'जमा करें',
        NoRecordsavailable: "कोई रिकॉर्ड उपलब्ध नहीं है",

    },
    kn: {
        star: 'ನಕ್ಷತ್ರ',
        welcomeBack: 'ಮರಳಿ ಸ್ವಾಗತ',
        loginAndenjoy: 'ಲಾಗಿನ್ ಮಾಡಿ ಮತ್ತು ಆನಂದಿಸಿ!',
        email: 'ಇಮೇಲ್',
        password: 'ಗುಪ್ತಪದ',
        enterEmail: 'ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ',
        enterPassword: 'ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ',
        login: 'ಲಾಗಿನ್',
        yourDashboard: 'ನಿಮ್ಮ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        totalVideos: 'ಒಟ್ಟು ರಚಿಸಿದ ವೀಡಿಯೊ',
        history: 'ಇತಿಹಾಸ',
        acceptedMessage: 'ಸ್ವೀಕರಿಸಿದ ಸಂದೇಶ',
        wantsVideo: 'ವೀಡಿಯೊ ಸಲ್ಲಿಸಿದೆ',
        fansMessages: 'ಅಭಿಮಾನಿಗಳು ಸಂದೇಶಗಳು',
        noDataAvailable: 'ಯಾವುದೇ ಮಾಹಿತಿ ಇಲ್ಲ',
        btnViewDetails: 'ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        fanMessage: 'ಅಭಿಮಾನಿ ಸಂದೇಶ',
        requestedPerson: 'ಯಾವ ವಿನಂತಿ',
        messageFor: 'ಗಾಗಿ ಸಂದೇಶ',
        message: 'ಸಂದೇಶ',
        requestdate: 'ವಿನಂತಿಯ ದಿನಾಂಕ',
        decline: 'ತಿರಸ್ಕರಿಸಿ',
        accept: 'ಸ್ವೀಕರಿಸಿ',
        upload: 'ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
        fanHistory: 'ಅಭಿಮಾನಿಗಳ ಇತಿಹಾಸ',
        home: 'ಮನೆ',
        likes: 'ಇಷ್ಟವಾಯಿತು',
        Comments: 'ಪ್ರತಿಕ್ರಿಯೆಗಳು',
        PeopleHaveliked: 'ಜನರು ಇಷ್ಟಪಟ್ಟಿದ್ದಾರೆ',
        madeComments: 'ಜನರು ಕಾಮೆಂಟ್ ಮಾಡಿದ್ದಾರೆ',
        btnViewProfile: 'ಪ್ರೊಫೈಲ್ ವೀಕ್ಷಿಸಿ',
        profile: 'ವಿವರ',
        invalidLoginPass: 'ಅಮಾನ್ಯ ಲಾಗಿನ್ ಅಥವಾ ಪಾಸ್ವರ್ಡ್ !! ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        somethingWentwrong: 'ಏನೋ ತಪ್ಪಾಗಿದೆ !! ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        myProfile: 'ನನ್ನ ಪ್ರೊಫೈಲ್',
        fansRecord: 'ಅಭಿಮಾನಿಗಳ ದಾಖಲೆ',
        name: 'નામ',
        profession: 'ವೃತ್ತಿ',
        bio: 'ಬಯೋ',
        setPrice: 'ಬೆಲೆಯನ್ನು ನಿಗದಿಪಡಿಸಿ',
        videoProfile: 'ಫೋಟೋ ವಿವರ',
        photoProfile: 'ഫോട്ടോ പ്രൊഫൈൽ',
        socialProfile: 'ಸಾಮಾಜಿಕ ವಿವರ',
        uploadImage: 'ಫೋಟೋ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
        uploadVideo: 'ವೀಡಿಯೊ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
        newVideo: 'ಹೊಸ ವೀಡಿಯೊ ಅಥವಾ ಫೋಟೋ ಅಪ್ಲೋಡ್',
        instagram: 'Instagram',
        view: 'ನೋಡಿ',
        noHistoryAvailable: 'ಯಾವುದೇ ಇತಿಹಾಸ ಲಭ್ಯವಿಲ್ಲ',
        videoOrImage: 'ಹೊಸ ವೀಡಿಯೊ ಅಥವಾ ಫೋಟೋ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
        createdVideofor: 'ವೀಡಿಯೊವನ್ನು ರಚಿಸಿದೆ',
        logout: 'ಲಾಗ್ಔಟ್',
        cancel: 'ರದ್ದುಮಾಡಿ',
        imageUploaded: 'ಅಪ್ಲೋಡ್ ಹೋದರು',
        videoUploaded: 'ವೀಡಿಯೊ ಅಪ್ಲೋಡ್',
        Submit: 'ಸಲ್ಲಿಸು',
        NoRecordsavailable: "ಯಾವುದೇ ದಾಖಲೆಗಳು ಲಭ್ಯವಿಲ್ಲ",


    },
    ml: {
        star: 'നക്ഷത്രം',
        welcomeBack: 'തിരികെ സ്വാഗതം',
        loginAndenjoy: 'ലോഗിൻ ചെയ്ത് ആസ്വദിക്കൂ!',
        email: 'ഇമെയിൽ',
        password: 'പാസ്വേഡ്',
        enterEmail: 'നിങ്ങളുടെ ഇമെയിൽ നൽകുക',
        enterPassword: 'നിങ്ങളുടെ പാസ്‌വേഡ് നൽകുക',
        login: 'ലോഗിൻ',
        yourDashboard: 'നിങ്ങളുടെ ഡാഷ്‌ബോർഡ്',
        totalVideos: 'ആകെ സൃഷ്ടിച്ച വീഡിയോ',
        history: 'ചരിത്രം',
        acceptedMessage: 'സ്വീകരിച്ച സന്ദേശം',
        wantsVideo: 'ഒരു വീഡിയോ സമർപ്പിച്ചു',
        fansMessages: 'ആരാധകരുടെ സന്ദേശങ്ങൾ',
        noDataAvailable: 'ഡാറ്റ ലഭ്യമല്ല',
        btnViewDetails: 'വിശദാംശങ്ങൾ കാണുക',
        fanMessage: 'ഫാൻ സന്ദേശം',
        requestedPerson: 'എന്ത് അഭ്യർത്ഥന',
        messageFor: 'എന്തു സന്ദേശം',
        message: 'സന്ദേശം',
        requestdate: 'അഭ്യർത്ഥന തീയതി',
        decline: 'നിരസിക്കുക',
        accept: 'അംഗീകരിക്കുക',
        upload: 'അപ്‌ലോഡുചെയ്യുക',
        fanHistory: 'ആരാധക ചരിത്രം',
        home: 'വീട്',
        likes: 'ഇഷ്ടപ്പെട്ടു',
        Comments: 'അഭിപ്രായങ്ങൾ',
        PeopleHaveliked: 'ആളുകൾ ഇഷ്ടപ്പെട്ടു',
        madeComments: 'ആളുകൾ അഭിപ്രായമിട്ടു',
        btnViewProfile: 'വ്യക്തിവിവരങ്ങൾ കാണുക',
        profile: 'പ്രൊഫൈൽ',
        invalidLoginPass: 'ലോഗിൻ അല്ലെങ്കിൽ പാസ്‌വേഡ് അസാധുവാണ് !! ദയവായി വീണ്ടും ശ്രമിക്കുക',
        somethingWentwrong: 'എന്തോ കുഴപ്പം സംഭവിച്ചു !! ദയവായി വീണ്ടും ശ്രമിക്കുക',
        myProfile: 'എന്റെ പ്രൊഫൈൽ',
        fansRecord: 'ആരാധകരുടെ റെക്കോർഡ്',
        name: 'ಹೆಸರು',
        profession: 'തൊഴിൽ',
        bio: 'ബയോ',
        setPrice: 'വില നിശ്ചയിക്കുക',
        videoProfile: 'വീഡിയോ പ്രൊഫൈൽ',
        photoProfile: 'ഫോട്ടോ പ്രൊഫൈൽ',
        socialProfile: 'സാമൂഹിക പ്രൊഫൈൽ',
        uploadImage: 'ഫോട്ടോ അപ്‌ലോഡുചെയ്യുക',
        uploadVideo: 'വീഡിയോ അപ്‌ലോഡുചെയ്യുക',
        newVideo: 'പുതിയ വീഡിയോ അല്ലെങ്കിൽ ഫോട്ടോ അപ്ലോഡ്',
        instagram: 'ഇൻസ്റ്റാഗ്രാം',
        view: 'കാണുക',
        noHistoryAvailable: 'ചരിത്രമൊന്നും ലഭ്യമല്ല',
        videoOrImage: 'പുതിയ വീഡിയോ അല്ലെങ്കിൽ ഫോട്ടോ അപ്‌ലോഡുചെയ്യുക',
        createdVideofor: 'വീഡിയോ സൃഷ്ടിച്ചു',
        logout: 'ലോഗ് out ട്ട്',
        cancel: 'റദ്ദാക്കുക',
        imageUploaded: 'അപ്ലോഡ് പോയി',
        videoUploaded: 'വീഡിയോ അപ്‌ലോഡുചെയ്‌തു',
        Submit: 'സമർപ്പിക്കുക',
        NoRecordsavailable: "റെക്കോർഡുകളൊന്നും ലഭ്യമല്ല",


    },
    mr: {
        star: 'स्टार',
        welcomeBack: 'स्वागत परत',
        loginAndenjoy: 'लॉगिन करा आणि आनंद घ्या!',
        email: 'ईमेल',
        password: 'संकेतशब्द',
        enterEmail: 'तुमचा ईमेल टाका',
        enterPassword: 'आपला संकेतशब्द प्रविष्ट करा',
        login: 'लॉगिन',
        yourDashboard: 'आपला डॅशबोर्ड',
        totalVideos: 'एकूण तयार केलेला व्हिडिओ',
        history: 'इतिहास',
        acceptedMessage: 'स्वीकारलेला संदेश',
        wantsVideo: 'व्हिडिओ सबमिट केला आहे',
        fansMessages: 'चाहते संदेश',
        noDataAvailable: 'माहिती उपलब्ध नाही',
        btnViewDetails: 'तपशील पहा',
        fanMessage: 'चाहता संदेश',
        requestedPerson: 'काय विनंती',
        messageFor: 'साठी संदेश',
        message: 'संदेश',
        requestdate: 'विनंतीची तारीख',
        decline: 'नाकारणे',
        accept: 'स्वीकारा',
        upload: 'अपलोड करा',
        fanHistory: 'चाहता इतिहास',
        home: 'मुख्यपृष्ठ',
        likes: 'आवडले',
        Comments: 'टिप्पण्या',
        PeopleHaveliked: 'लोकांना आवडले आहे',
        madeComments: 'लोकांनी प्रतिक्रिया दिल्या आहेत',
        btnViewProfile: 'प्रोफाइल पहा',
        profile: 'प्रोफाइल',
        invalidLoginPass: 'अवैध लॉगिन किंवा संकेतशब्द !! कृपया पुन्हा प्रयत्न करा',
        somethingWentwrong: 'काहीतरी चूक झाली !! कृपया पुन्हा प्रयत्न करा',
        myProfile: 'माझे प्रोफाइल',
        fansRecord: 'चाहते रेकॉर्ड',
        name: 'नाव',
        profession: 'व्यवसाय',
        bio: 'बायो',
        setPrice: 'किंमत ठरवा',
        videoProfile: 'व्हिडिओ प्रोफाइल',
        photoProfile: 'फोटो प्रोफाइल',
        socialProfile: 'सामाजिक प्रोफाइल',
        uploadImage: 'फोटो अपलोड करा',
        uploadVideo: 'व्हिडिओ अपलोड करा',
        newVideo: 'नवीन व्हिडिओ किंवा फोटो अपलोड करा',
        instagram: 'इन्स्टाग्राम',
        view: 'पहा',
        noHistoryAvailable: 'इतिहास उपलब्ध नाही',
        videoOrImage: 'नवीन व्हिडिओ किंवा फोटो अपलोड करा',
        createdVideofor: 'व्हिडिओ तयार केला आहे',
        logout: 'लॉगआउट',
        cancel: 'रद्द करा',
        imageUploaded: 'फोटो अपलोड केला',
        videoUploaded: 'व्हिडिओ अपलोड केला',
        Submit: 'सबमिट करा',
        NoRecordsavailable: "रेकॉर्ड उपलब्ध नाहीत",


    },
    pa: {
        star: 'ਤਾਰਾ',
        welcomeBack: 'ਵਾਪਸ ਸਵਾਗਤ',
        loginAndenjoy: 'ਲੌਗਇਨ ਕਰੋ ਅਤੇ ਅਨੰਦ ਲਓ!',
        email: 'ਈ - ਮੇਲ',
        password: 'ਪਾਸਵਰਡ',
        enterEmail: 'ਆਪਣਾ ਈ - ਮੇਲ ਭਰੋ',
        enterPassword: 'ਆਪਣਾ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ',
        login: 'ਲਾਗਿਨ',
        yourDashboard: 'ਤੁਹਾਡਾ ਡੈਸ਼ਬੋਰਡ',
        totalVideos: 'ਕੁੱਲ ਬਣਾਇਆ ਵੀਡੀਓ',
        history: 'ਇਤਿਹਾਸ',
        acceptedMessage: 'ਸਵੀਕਾਰਿਆ ਸੁਨੇਹਾ',
        wantsVideo: 'ਨੇ ਇਕ ਵੀਡੀਓ ਸੌਂਪਿਆ ਹੈ',
        fansMessages: 'ਪੱਖੇ ਸੁਨੇਹੇ',
        noDataAvailable: 'ਕੋਈ ਡਾਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ',
        btnViewDetails: 'ਵੇਰਵੇ ਵੇਖੋ',
        fanMessage: 'ਪੱਖਾ ਸੁਨੇਹਾ',
        requestedPerson: 'ਕੀ ਬੇਨਤੀ',
        messageFor: 'ਲਈ ਸੁਨੇਹਾ',
        message: 'ਸੁਨੇਹਾ',
        requestdate: 'ਬੇਨਤੀ ਮਿਤੀ',
        decline: 'ਰੱਦ ਕਰੋ',
        accept: 'ਸਵੀਕਾਰ ਕਰੋ',
        upload: 'ਅਪਲੋਡ ਕਰੋ',
        fanHistory: 'ਪ੍ਰਸ਼ੰਸਕ ਇਤਿਹਾਸ',
        home: 'హోమ్',
        likes: 'ਪਸੰਦ',
        Comments: 'ਟਿਪਣੀਆਂ',
        PeopleHaveliked: 'ਲੋਕਾਂ ਨੇ ਪਸੰਦ ਕੀਤਾ ਹੈ',
        madeComments: 'ਲੋਕਾਂ ਨੇ ਟਿੱਪਣੀਆਂ ਕੀਤੀਆਂ ਹਨ',
        btnViewProfile: 'ਪ੍ਰੋਫਾਈਲ ਵੇਖੋ',
        profile: 'ਪ੍ਰੋਫਾਈਲ',
        invalidLoginPass: 'ਗਲਤ ਲੌਗਇਨ ਜਾਂ ਪਾਸਵਰਡ !! ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜੀ',
        somethingWentwrong: 'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ !! ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜੀ',
        myProfile: 'ਮੇਰੀ ਪ੍ਰੋਫਾਈਲ',
        fansRecord: 'ਪ੍ਰਸ਼ੰਸਕਾਂ ਦਾ ਰਿਕਾਰਡ',
        name: 'ਨਾਮ',
        profession: 'ਪੇਸ਼ੇ',
        bio: 'ਬਾਇਓ',
        setPrice: 'ਕੀਮਤ ਨਿਰਧਾਰਤ ਕਰੋ',
        videoProfile: 'ਵੀਡੀਓ ਪ੍ਰੋਫਾਈਲ',
        photoProfile: 'ਫੋਟੋ ਪ੍ਰੋਫਾਈਲ',
        socialProfile: 'ਸੋਸ਼ਲ ਪ੍ਰੋਫਾਈਲ',
        uploadImage: 'ਫੋਟੋ ਅਪਲੋਡ ਕਰੋ',
        uploadVideo: 'ਵੀਡੀਓ ਅਪਲੋਡ ਕਰੋ',
        newVideo: 'ਨਵੀਂ ਵੀਡੀਓ ਜਾਂ ਫੋਟੋ ਅਪਲੋਡ ਕਰੋ',
        instagram: 'ਇੰਸਟਾਗ੍ਰਾਮ',
        view: 'ਦੇਖੋ',
        noHistoryAvailable: 'ਕੋਈ ਇਤਿਹਾਸ ਉਪਲਬਧ ਨਹੀਂ',
        videoOrImage: 'ਨਵੀਂ ਵੀਡੀਓ ਜਾਂ ਫੋਟੋ ਅਪਲੋਡ ਕਰੋ',
        createdVideofor: 'ਵੀਡੀਓ ਬਣਾਈ ਹੈ',
        logout: 'లాగ్అవుట్',
        cancel: 'ਰੱਦ ਕਰੋ',
        imageUploaded: 'ਫੋਟੋ ਅਪਲੋਡ ਕੀਤੀ ਗਈ',
        videoUploaded: 'ਵੀਡੀਓ ਅਪਲੋਡ ਕੀਤਾ ਗਿਆ',
        Submit: 'ਜਮ੍ਹਾਂ ਕਰੋ',
        NoRecordsavailable: "ਕੋਈ ਰਿਕਾਰਡ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",

    },
    ta: {
        star: 'நட்சத்திரம்',
        welcomeBack: 'மீண்டும் வருக',
        loginAndenjoy: 'உள்நுழைந்து மகிழுங்கள்!',
        email: 'மின்னஞ்சல்',
        password: 'கடவுச்சொல்',
        enterEmail: 'மின்னஞ்சலை பதிவுசெய்',
        enterPassword: 'உங்கள் கடவுச்சொல்லை உள்ளிடவும்',
        login: 'உள்நுழைய',
        yourDashboard: 'உங்கள் டாஷ்போர்டு',
        totalVideos: 'மொத்தம் உருவாக்கப்பட்ட வீடியோ',
        history: 'வரலாறு',
        acceptedMessage: 'ஏற்றுக்கொள்ளப்பட்ட செய்தி',
        wantsVideo: 'வீடியோ கோரிக்கை கியா',
        fansMessages: 'ரசிகர்கள் செய்திகள்',
        noDataAvailable: 'தரவு எதுவும் கிடைக்கவில்லை',
        btnViewDetails: 'விபரங்களை பார்',
        fanMessage: 'விசிறி செய்தி',
        requestedPerson: 'டேல்ஸ் கோர',
        messageFor: 'కోసం సందేశం',
        message: 'செய்தி',
        requestdate: 'கோரிக்கை தேதி',
        decline: 'சரிவு',
        accept: 'ஏற்கவும்',
        upload: 'பதிவேற்றம்',
        fanHistory: 'ரசிகர் வரலாறு',
        home: 'முகப்பு',
        likes: 'விரும்பியது',
        Comments: 'கருத்துக்கள்',
        PeopleHaveliked: 'மக்கள் விரும்பியுள்ளனர்',
        madeComments: 'மக்கள் கருத்து தெரிவித்துள்ளனர்',
        btnViewProfile: 'சுயவிவரம் காண',
        profile: 'விவரம்',
        invalidLoginPass: 'தவறான உள்நுழைவு அல்லது கடவுச்சொல் !! மீண்டும் முயற்சிக்கவும்',
        somethingWentwrong: 'ஏதோ தவறு ஏற்பட்டது !! மீண்டும் முயற்சிக்கவும்',
        myProfile: 'எனது சுயவிவரம்',
        fansRecord: 'ரசிகர்கள் பதிவு',
        name: 'பெயர்',
        profession: 'தொழிலை',
        bio: 'உயிரி',
        setPrice: 'விலையை நிர்ணயிக்கவும்',
        videoProfile: 'வீடியோ சுயவிவரம்',
        photoProfile: 'புகைப்பட சுயவிவரம்',
        socialProfile: 'சமூக சுயவிவரம்',
        uploadImage: 'புகைப்படத்தைப் பதிவேற்றவும்',
        uploadVideo: 'வீடியோவைப் பதிவேற்றவும்',
        newVideo: 'புதிய வீடியோ அல்லது புகைப்பட பதிவேற்ற',
        instagram: 'புகைப்படம்ஒரு',
        view: 'காண்க',
        noHistoryAvailable: 'வரலாறு கிடைக்கவில்லை',
        videoOrImage: 'புதிய வீடியோ அல்லது புகைப்படத்தைப் பதிவேற்றவும்',
        createdVideofor: 'வீடியோவை உருவாக்கியுள்ளது',
        logout: 'வெளியேறு',
        cancel: 'ரத்து',
        imageUploaded: 'பதிவேற்றம் வெண்ட்',
        videoUploaded: 'வீடியோ பதிவேற்றிய',
        Submit: 'சமர்ப்பி',
        NoRecordsavailable: "பதிவுகள் எதுவும் கிடைக்கவில்லை",


    },
    te: {
        star: 'నక్షత్రం',
        welcomeBack: 'పునఃస్వాగతం',
        loginAndenjoy: 'లాగిన్ చేసి ఆనందించండి!',
        email: 'ఇమెయిల్',
        password: 'పాస్వర్డ్',
        enterEmail: 'మీ ఇమెయిల్‌ను నమోదు చేయండి',
        enterPassword: 'మీ పాస్‌వర్డ్‌ను నమోదు చేయండి',
        login: 'లాగిన్',
        yourDashboard: 'మీ డాష్‌బోర్డ్',
        totalVideos: 'మొత్తం సృష్టించిన వీడియో',
        history: 'చరిత్ర',
        acceptedMessage: 'అంగీకరించిన సందేశం',
        wantsVideo: 'వీడియోను సమర్పించింది',
        fansMessages: 'అభిమానులు సందేశాలు',
        noDataAvailable: 'సమాచారం అందుబాటులో లేదు',
        btnViewDetails: 'వివరాలను చూడండి',
        fanMessage: 'అభిమాని సందేశం',
        requestedPerson: 'ఏ అభ్యర్థన',
        messageFor: '',
        message: 'సందేశం',
        requestdate: 'అభ్యర్థన తేదీ',
        decline: 'డిక్లైన్',
        accept: 'అంగీకరించు',
        upload: 'అప్లోడ్',
        fanHistory: 'అభిమాని చరిత్ర',
        home: 'హోమ్',
        likes: 'ఇష్టపడ్డారు',
        Comments: 'వ్యాఖ్యలు',
        PeopleHaveliked: 'ప్రజలు ఇష్టపడ్డారు',
        madeComments: 'ప్రజలు వ్యాఖ్యలు చేశారు',
        btnViewProfile: 'ప్రొఫైల్ చూడు',
        profile: 'ప్రొఫైల్',
        invalidLoginPass: 'చెల్లని లాగిన్ లేదా పాస్వర్డ్ !! దయచేసి మళ్ళీ ప్రయత్నించండి',
        somethingWentwrong: 'ఏదో తప్పు జరిగింది !! దయచేసి మళ్ళీ ప్రయత్నించండి',
        myProfile: 'నా ప్రొఫైల్',
        fansRecord: 'అభిమానుల రికార్డ్',
        name: 'పేరు',
        profession: 'వృత్తి',
        bio: 'బయో',
        setPrice: 'ధరను నిర్ణయించండి',
        videoProfile: 'వీడియో ప్రొఫైల్',
        photoProfile: 'ఫోటో ప్రొఫైల్',
        socialProfile: 'సామాజిక ప్రొఫైల్',
        uploadImage: 'ఫోటోను అప్‌లోడ్ చేయండి',
        uploadVideo: 'వీడియోను అప్‌లోడ్ చేయండి',
        newVideo: 'క్రొత్త వీడియో లేదా ఫోటోను అప్‌లోడ్ చేయండి',
        instagram: 'ఇన్స్టాగ్రామ్',
        view: 'చూడండి',
        noHistoryAvailable: 'చరిత్ర అందుబాటులో లేదు',
        videoOrImage: 'క్రొత్త వీడియో లేదా ఫోటోను అప్‌లోడ్ చేయండి',
        createdVideofor: 'వీడియోను సృష్టించింది',
        logout: 'లాగ్అవుట్',
        cancel: 'రద్దు',
        imageUploaded: 'ఫోటో అప్‌లోడ్ చేయబడింది',
        videoUploaded: 'వీడియో అప్‌లోడ్ చేయబడింది',
        Submit: 'సమర్పించండి',
        NoRecordsavailable: "రికార్డులు అందుబాటులో లేవు",

    },
}

const i18n = new VueI18n({
    locale: 'hi', // set locale
    fallbackLocale: 'hi', // set fallback locale
    messages // set locale messages
})

export default i18n